if (!customElements.get('quickview-media')) {
  customElements.define(
    'quickview-media',
    class QuickviewMedia extends HTMLElement {
      constructor() {
        super();

        this.productId = this.dataset.productId;

        this.modal = this.closest('.modal');

        this.images = this.querySelectorAll('.product-quickview__image');
        this.thumbnails = this.querySelectorAll(
          '.product-quickview__thumbnail'
        );

        this.thumbnails.forEach((thumbnail, index) => {
          thumbnail.addEventListener('click', () => {
            this.changeImage(index);
          });
        });

        if (window.location.href.includes(`modal=${this.productId}`)) {
          this.modal.show();
        }
      }

      changeImage(selected) {
        this.images.forEach((image, index) => {
          if (selected == index) {
            image.classList.remove('hidden');
            image.setAttribute('aria-hidden', 'false');
          } else {
            image.classList.add('hidden');
            image.setAttribute('aria-hidden', 'true');
          }
        });

        this.thumbnails.forEach((thumbnail, index) => {
          if (selected == index) {
            thumbnail.setAttribute('aria-selected', 'true');
          } else {
            thumbnail.setAttribute('aria-selected', 'false');
          }
        });
      }
    }
  );
}
